import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/common/Layout';
import Home from '@/pages/Home';

const Services = lazy(() => import('@/pages/Services'));
const About = lazy(() => import('@/pages/About'));
const Contact = lazy(() => import('@/pages/Contact'));
const NotFoundPage = lazy(() => import('@/features/NotFound/NotFoundPage'));

function PageLoader() {
  return (
    <div
      className="grid min-h-[calc(100svh-4.6rem)] place-items-center pt-20"
      role="status"
      aria-label="Učitavanje stranice"
    >
      <span className="size-8 animate-spin rounded-full border-3 border-primary/25 border-t-primary" />
    </div>
  );
}

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/usluge" element={<Services />} />
            <Route path="/o-nama" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
};
